export default __webpack_public_path__ + "static/media/rackham_thumb.5cda41a1.jpg";